
import { Options, Vue } from 'vue-class-component';

@Options({})
export default class Home extends Vue {
    email = '';
    error = false;

    private async handleSubmit(e: Event): Promise<void> {
        e.preventDefault();
        const emailRegExp =
            /^(([^\s"(),.:;<>@[\\\]]+(\.[^\s"(),.:;<>@[\\\]]+)*)|(".+"))@((\[(?:\d{1,3}\.){3}\d{1,3}])|(([\dA-Za-z]+\.)+[A-Za-z]{2,}))$/;

        const isValidEmail = this.email.match(emailRegExp);

        this.error = false;
        if (isValidEmail === null) {
            this.error = true;
            return;
        }

        const credentials = {
            email: this.email,
        };

        // eslint-disable-next-line no-console
        console.log(credentials);
    }
}
